import { makeVar } from "@apollo/client"

// source of truth for current organization
export const currentOrgIdVar = makeVar("")
